import { userContext } from "./userContext";

export class Event {
    id : number;
    objectToSend : any;
    eventType : string;
    createdDate : string;
    userContext : userContext;
    eventSource : string;
    objectToSendType : string;
    errorCode : string;
    errorI18nKey : string;
    eventCategory : string;
    correlationId: string;
    posId : string;
    supplierId: number;
    merchantId: number;
}